<template>
  <Sidebar
    v-model:visible="createNewSidebarVisible"
    class="p-sidebar-lg modern-sidebar"
    position="right"
    :showCloseIcon="false"
  >
    <Loading
      v-if="creating"
      :title="'Creating ' + entityName + '...'"
      :full="false"
    />
    <div v-show="!creating" class="game-form-container">
      <div class="flex align-items-center mb-4">
        <h3 class="text-xl font-semibold m-0">✨ Create {{ entityName }}</h3>
        <!-- <Button
          @click="gamePreviewVisible = true"
          type="button"
          icon="pi pi-eye"
          class="ml-auto"
          label="Preview"
          size="small"
        ></Button> -->
      </div>
      <Form
        :fields="createFields"
        :context="newEntity"
        @onChange="updatePreviewEntity"
        @onAction="createEntity"
        :actionLabel="'Create'"
        :actionIcon="'pi pi-plus-circle'"
        class="game-form"
      />
    </div>
  </Sidebar>
  <Sidebar
    v-model:visible="updateSidebarVisible"
    class="p-sidebar-lg modern-sidebar"
    position="right"
    :showCloseIcon="false"
  >
    <Loading
      v-if="creating"
      :title="'Updating ' + entityName + '...'"
      :full="false"
    />
    <div v-show="!creating" class="game-form-container">
      <div class="flex align-items-center mb-4">
        <h3 class="text-xl font-semibold m-0">✨ Update {{ entityName }}</h3>
        <!-- <Button
          @click="gamePreviewVisible = true"
          type="button"
          icon="pi pi-eye"
          class="ml-auto"
          label="Preview"
          size="small"
        ></Button> -->
      </div>
      <Form
        :fields="updateFields"
        :context="selectedEntity"
        @onChange="updatePreviewEntity"
        @onAction="updateEntity"
        :actionLabel="'Update'"
        :actionIcon="'pi pi-cloud'"
        class="game-form"
      />
    </div>
  </Sidebar>

  <Dialog
    v-model:visible="gamePreviewVisible"
    :draggable="false"
    modal
    header="Header"
    :style="{ width: '40rem' }"
    class="modern-dialog"
  >
    <template #header>
      <div class="inline-flex align-items-center justify-content-center gap-3">
        <i class="fa fa-eye text-blue-500 text-xl"></i>
        <h3 class="font-semibold white-space-nowrap m-0 p-0 text-gray-800">
          Game Preview
        </h3>
      </div>
    </template>
    <div class="flex justify-content-center align-items-center p-4">
      <div>
        <div
          :style="
            'width: 395px; height: 115px;' +
            'background-image: url(' +
            previewEntity?.coverImageUrl +
            ')'
          "
          class="bg-cover bg-center bg-no-repeat bg-gray-500 border-round-lg mb-3"
        ></div>
        <h4 class="p-0 m-0 mb-2 text-gray-800 font-semibold">
          {{
            previewEntity?.titleLocalized?.translations?.find(
              (t) => t.languageCode === "en"
            )?.text
          }}
        </h4>
        <p class="p-0 m-0 text-sm text-gray-600">
          {{
            previewEntity?.descriptionLocalized?.translations?.find(
              (t) => t.languageCode === "en"
            )?.text
          }}
        </p>
      </div>
    </div>
  </Dialog>

  <Dialog
    v-model:visible="deleteGameDialogIsVisible"
    :draggable="false"
    modal
    header="Header"
    :style="{ width: '28rem' }"
    class="modern-dialog"
  >
    <template #header>
      <div class="inline-flex align-items-center justify-content-center gap-3">
        <i class="fa fa-exclamation-triangle text-red-500 text-xl"></i>
        <h3 class="font-semibold white-space-nowrap m-0 p-0 text-gray-800">
          Delete App Game
        </h3>
      </div>
    </template>
    <div class="text-center p-4">
      <div class="bg-red-50 border-round-lg p-4 mb-4">
        <p class="text-gray-700 mb-2">
          You are about to
          <span class="font-semibold text-red-600">delete</span> the app game
        </p>
        <p class="font-bold text-lg text-gray-800 mb-0">
          "{{ gameSelectedForDeletion?.title }}"
        </p>
      </div>
      <p class="text-gray-600 mb-4">
        This action cannot be undone. Please confirm your decision.
      </p>
      <div class="flex gap-3 justify-content-center">
        <Button
          @click="deleteGameDialogIsVisible = false"
          label="Cancel"
          severity="secondary"
          class="px-6 py-2 border-round-lg"
          outlined
        />
        <Button
          @click="deleteEntity(gameSelectedForDeletion.id)"
          icon="fa fa-trash"
          severity="danger"
          class="px-6 py-2 border-round-lg font-semibold"
          label="Delete Game"
        />
      </div>
    </div>
  </Dialog>

  <Dialog
    v-model:visible="enableAppGameMenuVisible"
    :draggable="false"
    modal
    header="Header"
    :style="{ width: '28rem' }"
    class="modern-dialog"
  >
    <template #header>
      <div class="inline-flex align-items-center justify-content-center gap-3">
        <i
          :class="
            appGamesMenuEnabled
              ? 'fa fa-stop-circle text-orange-500'
              : 'fa fa-play-circle text-green-500'
          "
          class="text-xl"
        ></i>
        <h3 class="font-semibold white-space-nowrap m-0 p-0 text-gray-800">
          {{ appGamesMenuEnabled ? "Disable" : "Enable" }} App Games Menu
        </h3>
      </div>
    </template>
    <div class="text-center p-4">
      <div
        :class="appGamesMenuEnabled ? 'bg-orange-50' : 'bg-green-50'"
        class="border-round-lg p-4 mb-4"
      >
        <p class="text-gray-700 mb-2">
          You are about to
          <span
            :class="
              appGamesMenuEnabled
                ? 'font-semibold text-orange-600'
                : 'font-semibold text-green-600'
            "
            >{{ appGamesMenuEnabled ? "disable" : "enable" }}</span
          >
          the App Games menu in the app
        </p>
      </div>
      <p class="text-gray-600 mb-4">Please confirm your action.</p>
      <div class="flex gap-3 justify-content-center">
        <Button
          @click="enableAppGameMenuVisible = false"
          label="Cancel"
          severity="secondary"
          class="px-6 py-2 border-round-lg"
          outlined
        />
        <Button
          @click="updateAppGamesMenuEnabled(!appGamesMenuEnabled)"
          :icon="appGamesMenuEnabled ? 'fa fa-stop' : 'fa fa-play'"
          :severity="appGamesMenuEnabled ? 'warning' : 'success'"
          class="px-6 py-2 border-round-lg font-semibold"
          :label="appGamesMenuEnabled ? 'Disable' : 'Enable'"
        />
      </div>
    </div>
  </Dialog>

  <div class="page-container">
    <div class="max-w-7xl mx-auto p-6">
      <!-- Header Section -->
      <div class="bg-white border-round-2xl shadow-1 p-6 mb-6">
        <div class="flex align-items-center justify-content-between">
          <div class="flex align-items-center gap-4">
            <div class="header-icon-container">
              <i class="fa fa-gamepad text-white text-2xl"></i>
            </div>
            <div>
              <div class="flex align-items-center gap-3 mb-2">
                <h1 class="font-bold text-gray-800 text-3xl m-0">
                  {{ pageTitle }}
                </h1>
                <div
                  :class="
                    appGamesMenuEnabled ? 'status-enabled' : 'status-disabled'
                  "
                  class="status-badge"
                  v-tooltip="
                    `App games menu is ${
                      appGamesMenuEnabled ? 'enabled' : 'disabled'
                    } in the App`
                  "
                >
                  <i
                    :class="
                      appGamesMenuEnabled
                        ? 'fa fa-check-circle'
                        : 'fa fa-times-circle'
                    "
                    class="text-sm"
                  ></i>
                  <span>{{
                    appGamesMenuEnabled ? "Enabled" : "Disabled"
                  }}</span>
                </div>
              </div>
              <p class="text-gray-600 m-0 text-lg">{{ pageDescription }}</p>
            </div>
          </div>
          <div class="flex gap-2">
            <Button
              @click="showCreate"
              :label="'New ' + entityName"
              icon="fa fa-plus"
              class="create-button"
            />
            <Button
              @click="enableAppGameMenuVisible = true"
              :class="
                !appGamesMenuEnabled
                  ? 'toggle-button toggle-enable'
                  : 'toggle-button toggle-disable'
              "
              :label="appGamesMenuEnabled ? 'Disable' : 'Enable'"
              :icon="`fa ${appGamesMenuEnabled ? 'fa-stop' : 'fa-play'}`"
              v-tooltip="
                `${
                  !appGamesMenuEnabled ? 'Enable' : 'Disable'
                } the app games menu in the App`
              "
            />
          </div>
        </div>
      </div>

      <Loading
        v-if="loading"
        :full="false"
        :title="'Loading ' + pageTitle + '...'"
      />

      <!-- Main Content -->
      <div v-else class="bg-white border-round-2xl shadow-1 overflow-hidden">
        <!-- Table Header -->
        <div class="table-header-section">
          <div class="flex align-items-center gap-3">
            <div class="bg-blue-100 p-2 border-round-lg">
              <i class="fa fa-list text-blue-600"></i>
            </div>
            <h2 class="text-xl font-semibold text-gray-800 m-0">
              Games Overview ({{ appGames.length }})
            </h2>
          </div>
        </div>

        <DataTable
          @row-click="onRowClicked"
          :value="appGames"
          dataKey="id"
          class="modern-datatable"
          :rowHover="true"
          responsiveLayout="scroll"
          stripedRows
        >
          <template #empty>
            <div class="text-center py-8">
              <i class="fa fa-inbox text-gray-400 text-4xl mb-3"></i>
              <p class="text-gray-500 text-lg m-0">No {{ pageTitle }} found</p>
              <p class="text-gray-400 text-sm m-0 mt-2">
                Create your first app game to get started
              </p>
            </div>
          </template>
          <template #loading>
            <div class="text-center py-6">
              <i class="fa fa-spinner fa-spin text-blue-500 text-2xl mb-2"></i>
              <p class="text-gray-600 m-0">Loading {{ pageTitle }}...</p>
            </div>
          </template>

          <Column header="">
            <template #header>
              <div class="flex align-items-center gap-2">
                <i class="fa fa-image text-gray-600"></i>
                <span class="font-semibold text-gray-700">Cover Image</span>
              </div>
            </template>
            <template #body="{ data }">
              <div class="py-2">
                <img
                  :src="data.coverImageUrl"
                  style="
                    width: 6rem;
                    border-radius: 0.5rem;
                    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
                  "
                />
              </div>
            </template>
          </Column>

          <Column header="">
            <template #header>
              <div class="flex align-items-center gap-2">
                <i class="fa fa-tag text-gray-600"></i>
                <span class="font-semibold text-gray-700">Title</span>
              </div>
            </template>
            <template #body="{ data }">
              <div class="flex align-items-center gap-3 py-2">
                <div>
                  <p class="font-semibold text-gray-800 m-0">
                    {{ data?.title }}
                  </p>
                </div>
              </div>
            </template>
          </Column>

          <Column header="">
            <template #header>
              <div class="flex align-items-center gap-2">
                <i class="fa fa-align-left text-gray-600"></i>
                <span class="font-semibold text-gray-700">Description</span>
              </div>
            </template>
            <template #body="{ data }">
              <p class="text-gray-600 m-0">{{ data?.description }}</p>
            </template>
          </Column>

          <Column header="">
            <template #header>
              <div class="flex align-items-center gap-2">
                <i class="fa fa-circle text-gray-600"></i>
                <span class="font-semibold text-gray-700">Status</span>
              </div>
            </template>
            <template #body="{ data }">
              <div class="flex">
                <div
                  :class="data.enabled ? 'status-enabled' : 'status-disabled'"
                  class="status-badge"
                >
                  <i
                    :class="
                      data.enabled ? 'fa fa-check-circle' : 'fa fa-times-circle'
                    "
                    class="text-sm"
                  ></i>
                  <span>{{ data.enabled ? "Enabled" : "Disabled" }}</span>
                </div>
              </div>
            </template>
          </Column>

          <Column header="">
            <template #header>
              <div class="flex align-items-center gap-2">
                <i class="fa fa-cog text-gray-600"></i>
                <span class="font-semibold text-gray-700">Actions</span>
              </div>
            </template>
            <template #body="{ data }">
              <div class="flex gap-2">
                <Button
                  @click.stop="showDeleteDialog(data)"
                  type="button"
                  icon="fa fa-trash"
                  class="action-button delete-button"
                  size="small"
                  v-tooltip.top="'Delete Game'"
                />
              </div>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useToast } from "primevue/usetoast";
import { uploadFile } from "@/services/fileUploadService";

export default {
  components: {},
  setup() {
    const storeActionGetEntities = "appGames/getAppGameListItems";
    const storeActionEnsureEntities = "appGames/ensureAppGameListItems";

    const storeGetterGetEntities = "appGames/appGameListItems";
    const storeActionCreateEntity = "appGames/createAppGame";
    const storeActionDeleteEntity = "appGames/deleteAppGame";
    const storeActionUpdateEntity = "appGames/updateAppGame";
    const storeActionUpdateAppGamesEnabled = "updateAppGamesMenuEnabled";

    const entityName = "App Game";
    const pageTitle = "App Games";
    const pageDescription = "Here you can manage your App Games";

    const store = useStore();
    const toast = useToast();

    const loading = ref(false);
    const creating = ref(false);

    const appGames = ref([]);

    const createNewSidebarVisible = ref(false);
    const updateSidebarVisible = ref(false);
    const gamePreviewVisible = ref(false);
    const enableAppGameMenuVisible = ref(false);
    const deleteGameDialogIsVisible = ref(false);

    const gameSelectedForDeletion = ref();

    const activeCountryCode = computed(() => {
      var activeAccountCountry = store.getters["activeAccountCountry"];
      var countryAccounts = store.getters["countryAccounts"];
      return countryAccounts?.find((x) => x.id == activeAccountCountry)
        ?.countryCode;
    });
    const appGamesMenuEnabled = computed(() => {
      var activeAccountCountry = store.getters["activeAccountCountry"];
      var countryAccounts = store.getters["countryAccounts"];
      return countryAccounts?.find((x) => x.id == activeAccountCountry)
        ?.appGamesEnabled;
    });

    const appGameTypes = [
      { title: "General", id: "General" },
      { title: "Staff only", id: "StaffOnly" },
      { title: "Staff excluded", id: "StaffExcluded" },
      { title: "Members only", id: "MembersOnly" },
    ];
    const newEntity = ref({
      titleLocalized: {
        translations: [
          { languageCode: "en", text: "" },
          { languageCode: "da", text: "" },
          { languageCode: "fi", text: "" },
          { languageCode: "no", text: "" },
        ],
      },
      descriptionLocalized: {
        translations: [
          { languageCode: "en", text: "" },
          { languageCode: "da", text: "" },
          { languageCode: "fi", text: "" },
          { languageCode: "no", text: "" },
        ],
      },
      scratcherRecurrenceText: {
        translations: [
          { languageCode: "en", text: "" },
          { languageCode: "da", text: "" },
          { languageCode: "fi", text: "" },
          { languageCode: "no", text: "" },
        ],
      },
      url: "",
      coverImageUrl: "",
      appGameType: "General",
      isScratcherWithAutoRegistration: false,
    });

    const selectedEntity = ref();
    const previewEntity = ref({
      titleLocalized: {
        translations: [
          { languageCode: "en", text: "" },
          { languageCode: "da", text: "" },
          { languageCode: "fi", text: "" },
          { languageCode: "no", text: "" },
        ],
      },
      scratcherRecurrenceText: {
        translations: [
          { languageCode: "en", text: "" },
          { languageCode: "da", text: "" },
          { languageCode: "fi", text: "" },
          { languageCode: "no", text: "" },
        ],
      },
      descriptionLocalized: {
        translations: [
          { languageCode: "en", text: "" },
          { languageCode: "da", text: "" },
          { languageCode: "fi", text: "" },
          { languageCode: "no", text: "" },
        ],
      },
      url: "",
      coverImageUrl: "",
    });

    // Current form context for conditional field evaluation
    const currentFormContext = ref(newEntity.value);

    const allCreateFields = ref([
      {
        id: "titleLocalized",
        type: "localized-text",
        title: "Title",
        help: "Name of the App game",
      },
      {
        id: "descriptionLocalized",
        type: "localized-text",
        title: "Description",
        help: "Description the App game",
      },
      {
        id: "isScratcherWithAutoRegistration",
        type: "switch",
        title: "Is Scratcher game with auto user registration",
        help: "Remember to enable auto user registration in Scratcher",
      },
      {
        id: "scratcherRecurrenceText",
        type: "localized-text",
        title: "Scratcher Recurrence",
        help: "How often the user can play the game. Shown on unsuccesful retry.",
        condition: (context) => context.isScratcherWithAutoRegistration === true,
      },
      {
        id: "coverImageUrl",
        type: "imageUpload",
        title: "Cover image",
        help: "Image that will be shown. Dimensions of 315 x 115 will be fully visible. Try to keep below 300kb in size",
      },
      {
        id: "appGameType",
        type: "dropdown",
        config: {
          options: appGameTypes,
          optionLabel: "title",
          optionValue: "id",
          placeholder: "Please select type",
        },
        title: "Type",
        help: "The type specifies which users can see the game",
      },
      {
        id: "url",
        type: "text-input",
        title: "Game Url",
        help: "Url to Scratcher game",
      },
    ]);

    const createFields = computed(() => {
      return allCreateFields.value.filter(field => {
        if (field.condition && typeof field.condition === 'function') {
          return field.condition(currentFormContext.value);
        }
        return true;
      });
    });

    const allUpdateFields = ref([
      {
        id: "titleLocalized",
        type: "localized-text",
        title: "Title",
        help: "Name of the App game",
      },
      {
        id: "descriptionLocalized",
        type: "localized-text",
        title: "Description",
        help: "Description the App game",
      },
      {
        id: "isScratcherWithAutoRegistration",
        type: "switch",
        title: "Is Scratcher game with auto user registration",
        help: "Remember to enable auto user registration in Scratcher",
      },
      {
        id: "scratcherRecurrenceText",
        type: "localized-text",
        title: "Scratcher Recurrence",
        help: "How often the user can play the game. Shown on unsuccesful retry.",
        condition: (context) => context.isScratcherWithAutoRegistration === true,
      },
      {
        id: "url",
        type: "text-input",
        title: "Game Url",
        help: "Url to Scratcher game",
      },
      {
        id: "coverImageUrl",
        type: "imageUpload",
        title: "Cover image",
        help: "Image that will be shown. Dimensions of 315 x 115 will be fully visible. Try to keep below 300kb in size",
      },
      {
        id: "appGameType",
        type: "dropdown",
        config: {
          options: appGameTypes,
          optionLabel: "title",
          optionValue: "id",
          placeholder: "Please select type",
        },
        title: "Type",
        help: "The type specifies which users can see the game",
      },
      {
        id: "enabled",
        type: "switch",
        title: "Is Enabled",
      },
    ]);

    const updateFields = computed(() => {
      return allUpdateFields.value.filter(field => {
        if (field.condition && typeof field.condition === 'function') {
          return field.condition(currentFormContext.value);
        }
        return true;
      });
    });

    function onRowClicked(payload) {
      selectedEntity.value = {
        ...payload.data,
        scratcherRecurrenceText: payload.data.scratcherRecurrenceText || {
          translations: [
            { languageCode: "en", text: "" },
            { languageCode: "da", text: "" },
            { languageCode: "fi", text: "" },
            { languageCode: "no", text: "" },
          ],
        },
      };
      currentFormContext.value = { ...selectedEntity.value };
      previewEntity.value = { ...selectedEntity.value };
      updateSidebarVisible.value = true;
    }

    function showDeleteDialog(game) {
      gameSelectedForDeletion.value = game;
      deleteGameDialogIsVisible.value = true;
    }

    async function createEntity(formContext) {
      creating.value = true;

      var imageUrl = await handleImageUpload(formContext);
      formContext.coverImageUrl = imageUrl;

      await store
        .dispatch(storeActionCreateEntity, formContext)
        .then(() => {
          toast.add({
            severity: "success",
            summary: "Success",
            detail: "App game created",
            life: 3000,
          });
          createNewSidebarVisible.value = false;
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Error",
            detail: "Could not create app game" + ": " + err,
            life: 3000,
          });
        })
        .finally(() => (creating.value = false));

      reloadData();
    }

    async function updateEntity(formContext) {
      creating.value = true;

      var imageUrl = await handleImageUpload(formContext);

      formContext.coverImageUrl = imageUrl;

      await store
        .dispatch(storeActionUpdateEntity, formContext)
        .then(() => {
          toast.add({
            severity: "success",
            summary: "Success",
            detail: "App game updated",
            life: 3000,
          });
          updateSidebarVisible.value = false;
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Error",
            detail: "Could not update app game" + ": " + err,
            life: 3000,
          });
        })
        .finally(() => (creating.value = false));

      reloadData();
    }

    async function deleteEntity(id) {
      deleteGameDialogIsVisible.value = false;
      await store
        .dispatch(storeActionDeleteEntity, id)
        .then(() => {
          toast.add({
            severity: "success",
            summary: "Success",
            detail: "App game deleted",
            life: 3000,
          });
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Error",
            detail: "Could not delete app game" + ": " + err,
            life: 3000,
          });
        })
        .finally(() => (creating.value = false));

      reloadData();
    }

    async function handleImageUpload(formContext) {
      if (formContext.coverImageUrl == selectedEntity.value?.coverImageUrl)
        return formContext.coverImageUrl;

      var imageContainer =
        formContext.titleLocalized.translations[0].text +
        "-" +
        activeCountryCode.value +
        "-images";
      var coverUrl = "";
      if (formContext.coverImageUrl) {
        var logoFile = await uploadFile(
          formContext.coverImageUrl,
          "games",
          imageContainer,
          store
        );
        coverUrl = logoFile.url;
      }
      return coverUrl;
    }

    async function updateAppGamesMenuEnabled(enable) {
      enableAppGameMenuVisible.value = false;
      await store
        .dispatch(storeActionUpdateAppGamesEnabled, enable)
        .then(() => {
          var detail = `The App games menu is now ${
            !enable ? "disabled" : "enabled"
          }`;
          toast.add({
            severity: "success",
            summary: "Success",
            detail: detail,
            life: 3000,
          });
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Error",
            detail: err,
            life: 3000,
          });
        });

      await store.dispatch("getCountryAccounts").catch((err) => {
        toast.add({
          severity: "error",
          summary: "Error",
          detail: err,
          life: 3000,
        });
      });

      reloadData();
    }

    async function reloadData() {
      loading.value = true;
      await store
        .dispatch(storeActionGetEntities)
        .then(() => {
          const loadedEntities = store.getters[storeGetterGetEntities];
          appGames.value = loadedEntities;
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Error",
            detail: "Could not get app games" + ": " + err,
            life: 3000,
          });
        })
        .finally(() => (loading.value = false));
    }

    async function loadRequiredData() {
      loading.value = true;
      await store
        .dispatch(storeActionEnsureEntities)
        .then(() => {
          const loadedEntities = store.getters[storeGetterGetEntities];
          appGames.value = loadedEntities;
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Error",
            detail: "Could not get app games" + ": " + err,
            life: 3000,
          });
        })
        .finally(() => (loading.value = false));
    }

    function showCreate() {
      currentFormContext.value = { ...newEntity.value };
      previewEntity.value = { ...newEntity.value };
      createNewSidebarVisible.value = true;
    }

    function updatePreviewEntity(formContext) {
      // Update our local context reference for conditional field evaluation
      // Do NOT update newEntity or selectedEntity here as it causes Form to re-render
      // and break File objects through JSON.stringify
      currentFormContext.value = { ...formContext };
      previewEntity.value = { ...formContext };
    }

    onMounted(() => {
      loadRequiredData();
    });

    return {
      entityName,
      pageTitle,
      pageDescription,

      createNewSidebarVisible,
      updateSidebarVisible,
      gamePreviewVisible,
      enableAppGameMenuVisible,
      deleteGameDialogIsVisible,

      updateFields,
      createFields,

      newEntity,
      selectedEntity,
      previewEntity,
      gameSelectedForDeletion,
      appGameTypes,

      loading,
      creating,

      appGamesMenuEnabled,

      appGames,

      updatePreviewEntity,

      updateAppGamesMenuEnabled,

      createEntity,
      updateEntity,
      deleteEntity,
      onRowClicked,
      showCreate,
      showDeleteDialog,
    };
  },
};
</script>

<style scoped>
/* Fixed background that doesn't scroll */
.page-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e0f2fe 100%);
  background-attachment: fixed;
}

/* Header icon container */
.header-icon-container {
  background: linear-gradient(135deg, #3b82f6 0%, #9333ea 100%);
  padding: 0.75rem;
  border-radius: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Create button styling */
.create-button {
  background: linear-gradient(135deg, #3b82f6 0%, #9333ea 100%) !important;
  border: none !important;
  padding: 0.75rem 1.5rem !important;
  border-radius: 0.75rem !important;
  font-weight: 600 !important;
  color: white !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.3s ease !important;
}

.create-button:hover {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
  transform: translateY(-1px) !important;
}

/* Toggle button styling */
.toggle-button {
  padding: 0.75rem 1.5rem !important;
  border-radius: 0.75rem !important;
  font-weight: 600 !important;
  color: white !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.3s ease !important;
  border: none !important;
}

.toggle-enable {
  background: linear-gradient(135deg, #4ade80 0%, #10b981 100%) !important;
}

.toggle-disable {
  background: linear-gradient(135deg, #fb923c 0%, #f97316 100%) !important;
}

.toggle-button:hover {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
  transform: translateY(-1px) !important;
}

/* Table header section */
.table-header-section {
  background: linear-gradient(90deg, #f9fafb 0%, #f1f5f9 100%);
  padding: 1.5rem;
  border-bottom: 1px solid #e5e7eb;
}

/* Status badge base styling */
.status-badge {
  padding: 0.5rem 1rem;
  border-radius: 0.75rem;
  font-weight: 500;
  text-align: center;
  min-width: max-content;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  color: white;
  transition: all 0.2s ease;
}

.status-badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

/* Specific badge colors */
.status-enabled {
  background: linear-gradient(135deg, #4ade80 0%, #10b981 100%);
}

.status-disabled {
  background: linear-gradient(135deg, #9ca3af 0%, #64748b 100%);
}

/* Action buttons */
.action-button {
  padding: 0.5rem !important;
  width: 2.5rem !important;
  height: 2.5rem !important;
  border-radius: 0.5rem !important;
  border: none !important;
  transition: all 0.2s ease !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.delete-button {
  background: #ef4444 !important;
  color: white !important;
}

.delete-button:hover {
  background: #dc2626 !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 8px rgba(239, 68, 68, 0.3) !important;
}

/* Custom styling for modern datatable */
:deep(.modern-datatable) {
  border: none;
  border-radius: 0;
}

:deep(.modern-datatable .p-datatable-header) {
  background: transparent;
  border: none;
  padding: 0;
}

:deep(.modern-datatable .p-datatable-thead > tr > th) {
  background: transparent;
  border: none;
  padding: 1rem 1.5rem;
  font-weight: 600;
  color: #374151;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

:deep(.modern-datatable .p-datatable-tbody > tr) {
  background: white;
  border: none;
  transition: all 0.2s ease;
}

:deep(.modern-datatable .p-datatable-tbody > tr:hover) {
  background: #f8fafc;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

:deep(.modern-datatable .p-datatable-tbody > tr > td) {
  border: none;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #f1f5f9;
}

:deep(.modern-datatable .p-datatable-tbody > tr:last-child > td) {
  border-bottom: none;
}

/* Striped rows with subtle styling */
:deep(.modern-datatable .p-datatable-tbody > tr:nth-child(even)) {
  background: #fdfdfe;
}

:deep(.modern-datatable .p-datatable-tbody > tr:nth-child(even):hover) {
  background: #f1f5f9;
}

/* Modern dialog styling */
:deep(.modern-dialog .p-dialog-header) {
  background: white;
  border-bottom: 1px solid #e5e7eb;
  border-radius: 0.75rem 0.75rem 0 0;
  padding: 1.5rem;
}

:deep(.modern-dialog .p-dialog-content) {
  background: white;
  border-radius: 0 0 0.75rem 0.75rem;
  padding: 0;
}

:deep(.modern-dialog .p-dialog) {
  border-radius: 0.75rem;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  border: none;
}

/* Modern sidebar styling */
.modern-sidebar {
  --sidebar-width: 550px;
}

.modern-sidebar :deep(.p-sidebar) {
  border-radius: 16px 0 0 16px;
  box-shadow: -5px 0 30px rgba(0, 0, 0, 0.1);
}

.game-form-container {
  padding: 0.5rem;
}

.game-form :deep(.p-dropdown),
.game-form :deep(.p-calendar),
.game-form :deep(.p-inputtext),
.game-form :deep(.p-multiselect) {
  border-radius: 8px;
}

.game-form :deep(.p-button) {
  border-radius: 8px;
  transition: transform 0.2s;
}

.game-form :deep(.p-button:hover) {
  transform: translateY(-1px);
}

.game-form :deep(.p-field) {
  margin-bottom: 1.5rem;
}

.game-form :deep(.p-field label) {
  margin-bottom: 0.5rem;
  font-weight: 500;
}

/* Add subtle hover effect to form elements */
.game-form :deep(.p-inputtext:hover),
.game-form :deep(.p-dropdown:hover),
.game-form :deep(.p-multiselect:hover) {
  border-color: var(--primary-color);
}

/* Improve spacing between sections */
.game-form :deep(.form-section) {
  margin-bottom: 2rem;
  padding: 1rem;
  background: var(--surface-card);
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

/* Loading and empty state styling */
.text-center i {
  display: block;
  margin: 0 auto;
}

/* Responsive improvements */
@media (max-width: 768px) {
  :deep(.modern-datatable .p-datatable-thead > tr > th),
  :deep(.modern-datatable .p-datatable-tbody > tr > td) {
    padding: 0.75rem 1rem;
  }

  .max-w-7xl {
    max-width: 100%;
  }

  .p-6 {
    padding: 1rem;
  }

  .status-badge {
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
  }
}

/* Smooth scrolling for responsive table */
:deep(.p-datatable-wrapper) {
  border-radius: 0;
}

/* Ensure proper shadow styling */
.shadow-1 {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}
</style>
